import { Routes } from '@angular/router';

import { LOCATIONS } from './content/locations.data';
import { SERVICES } from './content/services.data';

/**
 * Paths mirror the old WordPress site exactly, so every indexed URL keeps
 * working rather than being redirected somewhere approximate.
 *
 * The short paths used while building (/services, /pricing, ...) redirect to the
 * canonical ones so older internal links do not break.
 */
const serviceRoutes: Routes = SERVICES.map((service) => ({
  path: service.slug,
  loadComponent: () =>
    import('./pages/service-detail.component').then((m) => m.ServiceDetailComponent),
  // withComponentInputBinding() binds route data to matching component inputs.
  data: { slug: service.slug },
}));

const locationRoutes: Routes = LOCATIONS.map((location) => ({
  path: location.slug,
  loadComponent: () =>
    import('./pages/location-page.component').then((m) => m.LocationPageComponent),
  data: { slug: location.slug },
}));

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/home.component').then((m) => m.HomeComponent),
    title: 'Fine Shine Car Wash — Mobile Car Grooming in Hamilton',
  },

  // --- Core pages, at their WordPress paths ---
  {
    path: 'our-services',
    loadComponent: () => import('./pages/services.component').then((m) => m.ServicesComponent),
    title: 'Our Services — Fine Shine Car Wash',
  },
  {
    path: 'pricing-packages',
    loadComponent: () => import('./pages/pricing.component').then((m) => m.PricingComponent),
    title: 'Pricing & Packages — Fine Shine Car Wash',
  },
  {
    path: 'bookings',
    loadComponent: () => import('./pages/booking.component').then((m) => m.BookingComponent),
    title: 'Book a Wash — Fine Shine Car Wash',
  },
  {
    path: 'about-us',
    loadComponent: () => import('./pages/about.component').then((m) => m.AboutComponent),
    title: 'About Us — Fine Shine Car Wash',
  },
  {
    path: 'contact-us',
    loadComponent: () => import('./pages/contact.component').then((m) => m.ContactComponent),
    title: 'Contact — Fine Shine Car Wash',
  },
  {
    path: 'gallery',
    loadComponent: () => import('./pages/gallery.component').then((m) => m.GalleryComponent),
  },
  {
    path: 'faq',
    loadComponent: () => import('./pages/faq.component').then((m) => m.FaqComponent),
  },
  {
    path: 'reviews',
    loadComponent: () => import('./pages/reviews.component').then((m) => m.ReviewsComponent),
  },
  {
    path: 'career',
    loadComponent: () => import('./pages/careers.component').then((m) => m.CareersComponent),
  },
  {
    path: 'thank-you',
    loadComponent: () => import('./pages/thank-you.component').then((m) => m.ThankYouComponent),
  },

  // --- Individual service pages ---
  ...serviceRoutes,

  // --- Location / keyword landing pages ---
  ...locationRoutes,

  // --- Old WordPress pages with no equivalent ---
  { path: 'blog', redirectTo: '', pathMatch: 'full' },
  { path: 'landing', redirectTo: '', pathMatch: 'full' },

  // --- Short paths used during the build, kept working ---
  { path: 'services', redirectTo: 'our-services', pathMatch: 'full' },
  { path: 'pricing', redirectTo: 'pricing-packages', pathMatch: 'full' },
  { path: 'book', redirectTo: 'bookings', pathMatch: 'full' },
  { path: 'about', redirectTo: 'about-us', pathMatch: 'full' },
  { path: 'contact', redirectTo: 'contact-us', pathMatch: 'full' },

  { path: '**', redirectTo: '' },
];
